import { Component, OnInit } from '@angular/core';
import { MainPageShowModel, EntranceShowModel } from './main-page';
import { ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebSiteService } from '../services/website-service';

@Component({
  selector: 'm-app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  classes = ['bg-rose', 'bg-primary', 'bg-danger', 'bg-success', 'bg-warning', 'bg-info'];
  mainPage: MainPageShowModel;
  entranceLeft: EntranceShowModel[] = new Array<EntranceShowModel>();
  entranceRight: EntranceShowModel[] = new Array<EntranceShowModel>();

  segments: any[][];
  constructor(
    private services: WebSiteService,
    private cd: ChangeDetectorRef,
    public sanitization: DomSanitizer) {
  }

  ngOnInit(): void {
    this.mainPage = new MainPageShowModel();
    this.getMainPage();
    this.segments = [];
  }

  public getMainPage() {
    this.services.getMainPage().subscribe(resp => {
      this.mainPage = resp;
      this.mainPage.entrances.forEach(item => {
        if (item.position === 'left') {
          this.entranceLeft.push(item);
        } else {
          this.entranceRight.push(item);
        }
      });

      let i = 0;
      for (i = 0; i < this.mainPage.segments.length; i++) {

        if (this.segments[parseInt((i / 3).toString(), 0)] === undefined) {
          this.segments[parseInt((i / 3).toString(), 0)] = [];
        }
        this.segments[parseInt((i / 3).toString(), 0)][i % 3] = this.mainPage.segments[i];
        this.segments[parseInt((i / 3).toString(), 0)][i % 3].bgClass = this.classes[i];
      }

      this.cd.detectChanges();

      this.initEntranceMenu();
    });
  }

  public initEntranceMenu() {
    const navs = document.querySelectorAll('.card-nav-tabs .nav-link');
    Array.from(navs).forEach(item => {
      item.addEventListener('click', this.onNavClick);
    });

  }

  public onNavClick(event: MouseEvent) {
    let i = 0;
    event.preventDefault();
    const aTag = <HTMLElement>event.currentTarget;
    let divId = aTag.getAttribute('href');
    divId = divId.substring(1);
    let rootElement = aTag;

    for (i = 0; i < 10; i++) {
      if (rootElement.classList.contains('card-nav-tabs')) {
        break;
      }
      rootElement = rootElement.parentElement;
    }
    const activeElemnt = rootElement.getElementsByClassName('active');
    Array.from(activeElemnt).forEach(item => {
      item.classList.remove('active');
    });

    const tabPans = rootElement.getElementsByClassName('tab-pane');
    Array.from(tabPans).forEach(item => {
      if (item.id === divId) {
        item.className += ' active';
      }
    });
    aTag.className += ' active';
  }
}
